export const shouldShowFinalCertificationDecision = (scopeKey = '') => (
  !String(scopeKey).endsWith(':s1')
);
